import { MixInClassedAdsOpts, mixInClassedAds } from 'data-source/helpers/mixInClassedAds'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { MetaMapperOpts, metaMapper } from 'data-source/mappers/metaMapper'
import { TeamMemberMapperOpts, teamMemberMapper } from 'data-source/mappers/teamMemberMapper'
import { ApiComponent, ApiEventPageProps } from 'data-source/types.wp'
import { nullableString } from 'shared-code/conversion'
import { DSEventPage, DSNCAdClassed, DSResource } from 'shared-definitions/types'

interface EventPageMapperOpts<T extends DSResource, A extends ApiComponent>
  extends MetaMapperOpts,
    MixInClassedAdsOpts,
    TeamMemberMapperOpts {
  ampPagePath: string | null
  pagePath: string
  firstDesktopAd?: 'video' | 'plain'
  componentItemMapper: (input: A) => T | T[]
}

export function eventPageMapper<T extends DSResource, A extends ApiComponent>(
  input: ApiEventPageProps<A>,
  opts: EventPageMapperOpts<T, A>
): DSEventPage<T | DSNCAdClassed> {
  return {
    meta: metaMapper(input, ['Features'], opts),
    sections: null,
    head: headPropsMapper(input.head),
    ampPagePath: opts.ampPagePath,
    pagePath: opts.pagePath,
    resource: 'event-page',
    title: input.content.title,
    subtitle: nullableString(input.content.subtitle),
    firstPublishedDate: nullableString(input.content.first_published),
    date: input.content.date,
    authors: {
      authoredBy: input.authors.map(i => teamMemberMapper(i, opts)),
      reviewedBy: [],
      updatedBy: [],
    },
    image: imageMapper(input.content.image, opts),
    startsWithImage: input.content.starts_with_image ?? false,
    blocks: mixInClassedAds(input.content.content.flatMap(opts.componentItemMapper), opts),
  }
}
